export const usdMoneyFormatter = new Intl.NumberFormat('en-US', {
  currency: 'USD',
  style: 'currency',
});

export const largeNumberFormatter = new Intl.NumberFormat('en-US', {
  notation: 'standard',
});
